module.exports = window["__sharedEmotionJSX"];